define('plugin/client-field/view/ClientFieldsView',['require','marionette','plugin/client-field/view/ClientFieldItemView','plugin/client-field/view/BuiltIn/ClientFieldBuiltInNameView','plugin/client-field/view/BuiltIn/ClientFieldBuiltInEmailView','plugin/client-field/view/BuiltIn/ClientFieldBuiltInPhoneView','plugin/client-field/view/BuiltIn/ClientFieldBuiltInPasswordView','plugin/client-field/view/BuiltIn/ClientFieldBuiltInAddressView'],function (require) {

    var Parent = require('marionette').CompositeView;
    var ClientFieldItemView = require('plugin/client-field/view/ClientFieldItemView');
    var ClientFieldBuiltInNameView = require('plugin/client-field/view/BuiltIn/ClientFieldBuiltInNameView');
    var ClientFieldBuiltInEmailView = require('plugin/client-field/view/BuiltIn/ClientFieldBuiltInEmailView');
    var ClientFieldBuiltInPhoneView = require('plugin/client-field/view/BuiltIn/ClientFieldBuiltInPhoneView');
    var ClientFieldBuiltInPasswordView = require('plugin/client-field/view/BuiltIn/ClientFieldBuiltInPasswordView');
    var ClientFieldBuiltInAddressView = require('plugin/client-field/view/BuiltIn/ClientFieldBuiltInAddressView');

    return Parent.extend({

        template: '#client_fields_view',
        childViewContainer: '#sb_additional_fields',
        
        getChildView: function (model) {
            
            switch (model.id) {
                case 'name':
                    return ClientFieldBuiltInNameView;
                    
                case 'email':
                    return ClientFieldBuiltInEmailView;
                    
                case 'phone':
                    return ClientFieldBuiltInPhoneView;
                    
                case 'password':
                    return ClientFieldBuiltInPasswordView;
                    
                case 'address':
                    return ClientFieldBuiltInAddressView;
                
                default:
                    return ClientFieldItemView;
            }
            
        },

        childEvents: {
            'change': 'updateClientInfo'
        },
        collectionEvents: {
            'sync': 'updateClientInfo'
        },
        
        childViewOptions: function (model) {
            var errors = this._clientModel.validationError;
            
            switch (model.id) {
                case 'name':
                case 'email':
                case 'phone':
                case 'password':
                    return {
                        'clientModel': this.getOption('clientModel'),
                        'error': errors && errors[model.id]
                    };
                    
                case 'address':
                    return {
                        'clientModel': this.getOption('clientModel'),
                        // 'error': errors && errors.name
                    };
                    
                default:
                    var result = {
                        'clientModel': this.getOption('clientModel')
                    };
                    if (errors && errors['client_fields']) {
                        var errorMap = _.first(errors['client_fields']);
                        result.error = errorMap[model.get('name')];
                    } else {
                        result.error = errors && errors['client_fields/' + model.get('name')];
                    }
                    
                    return result;
            }
        },
        
        _onError: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        initialize: function () {
            this._clientModel = this.getOption('clientModel');
            this.listenTo(this._clientModel, 'invalid', this._onError); 

            this.updateClientInfo();
        },
        
        updateClientInfo: function () {
            var fields = {};
            var values = [];
            this.collection.each(function (model) {
                fields[model.get('name')] = model.get('value');
                if (model.get('type') === 'cloud') {
                    fields[model.get('name') + '_hash'] = model.get('filehash');
                }
                
                values.push({
                    'field_title': model.get('title'),
                    'field_type': model.get('type'),
                    'field_position': model.get('pos'),
                    'hash': model.get('type') === 'cloud' ? model.get('filehash') : undefined,
                    'value': model.get('value')
                });
            }, this);

            this._clientModel.set({
                'client_fields': fields, 
                'client_fields_values': values
            }, {
                silent: true
            });
        },
        
        onDomRefresh: function () {
            var fieldWithError = jQuery('.form-group.has-error', this.$el);
            if (fieldWithError.length) {
                fieldWithError[0].scrollIntoView();
            }
        },

    });

});
